import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';

import { FilesSelection } from '../upload-button/upload-button';

import styles from './upload-input.scss';

export interface UploadInputProps {
  children: React.ReactNode;
  className?: string;
  onUpload(data: FilesSelection): void;
  isMultipleAllowed?: boolean;
}

export class UploadInput extends React.Component<UploadInputProps> {
  private handleSubmit(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();
  }

  private handleUpload(e: React.ChangeEvent<HTMLInputElement>): void {
    const files = e.target.files;

    if (!files || _.isEmpty(files)) {
      return;
    }

    this.props.onUpload(files);
    e.target.value = '';
  }

  public render() {
    const { className, children, isMultipleAllowed } = this.props;

    return (
      <form
        encType="multipart/form-data"
        className={classNames(styles.form, className)}
        onSubmit={this.handleSubmit.bind(this)}
      >
        <span className={styles.uploadButton}>
          {children}
          <input
            data-hook="upload-input"
            onChange={this.handleUpload.bind(this)}
            name="file"
            type="file"
            className={styles.uploadInput}
            multiple={isMultipleAllowed}
          />
        </span>
      </form>
    );
  }
}
